import { React, Field, ErrorMessage, errorMessagesSection, FontAwesomeIcon,
         faExclamationCircle, infoPlaceholderSection, InputStyle, FormStyle }
         from "@/imports-files/components/input";

export function Input(props)
{
      const { label, name, infoPlaceholder, errorClass, style, type, ...rest } = props;
      
      return (
                < div className= {InputStyle.Form__InputSection}>
                  { props.isCurrency && <span>$</span> }
                  < Field name = { name } type = { type } style={style} { ...rest}/>
                  {

                    style != undefined ?  errorMessagesSection( name, FormStyle, props.formik, props.custom_class || '', props.custom_error_90 || '')
                                       :  infoPlaceholderSection(infoPlaceholder, FormStyle)
                  }
                </div>
             );
}

export function ScoreCardInput(props)
{
      const { label, name, infoPlaceholder, errorClass, style, type, ...rest } = props;
      
      return (
                < div className= {InputStyle.Form__ScoreCardInput}>
                  { props.isCurrency && <span>$</span> }
                  < Field name = { name } type = { type } style={style} { ...rest}/>
                  {

                    style != undefined ?  errorMessagesSection( name, FormStyle, props.formik, props.custom_class || '')
                                       :  ''
                  }
                </div>
             );
}

export function AutocompleteError(props){
  const {style, errorClass, infoPlaceholder, name, ...rest} = props
  return (
  style != undefined ?  errorMessagesSection( name, FormStyle, props.formik, props.custom_class || '', props.custom_error_90 || '')
                                       :  infoPlaceholderSection(infoPlaceholder, FormStyle)
  )
}

export function CustomAutocompleteError(props){
  const {style, errorClass, infoPlaceholder, name, ...rest} = props
  return (
  style != undefined ?  errorMessagesSection( name, FormStyle, props.formik, props.custom_class || '')
                                       :  ''
  )
}

